import axios from 'axios';
import { getTotalPage } from '../admin/Admin';

export const login = (data) => {
  return (dispatch) => {
    axios
      .post('/vendor/login', data)
      .then((data) => {
        localStorage.setItem('uid', data.data.data.id);
        localStorage.setItem('email', data.data.data.emailId);
        localStorage.setItem('name', data.data.data.name);
        localStorage.setItem('userLoginType', 'vendor');
        setAuthorizationHandler(data.data.token);
        localStorage.setItem(
          'vendorSuperCategoryId',
          JSON.stringify(data.data.data.superCategory)
        );
        dispatch({ type: 'VENDOR_LOGIN', payload: data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Login successful' }
        });
      })
      .catch((error) => {
        try {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { general: error.response.data.message }
          });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const deleteSuperCategories = (superCategoryId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/admin/super-category/delete/${superCategoryId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Super Category deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Super Category' }
        });
      }
    } else {
      try {
        await axios.delete(`/admin/super-category/delete/${superCategoryId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Super category deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete Super Category' }
        });
      }
    }
  };
};

export const upload = (data) => {
  return (dispatch) => {
    return axios.post('/upload/files', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
};
export const uploadCsv = (data) => {
  return (dispatch) => {
    return axios.post('/vendor/product/uploadCsv', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
};

export const addSubcategory = (subCategory) => {
  return (dispatch) => {
    axios
      .post('/vendor/sub-category/save', subCategory)
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Sub-category successfully added' }
        });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getSuperCategory = () => {
  return (dispatch) => {
    axios
      .get('/vendor/super-category')
      .then((data) => {
        dispatch({ type: 'GET_CITY_CATEGORY', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getMenus = () => {
  return (dispatch) => {
    axios
      .get('/vendor/menu/listing?page_number=1&per_page_limit=10')
      .then((data) => {
        dispatch({ type: 'GET_MENUS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getSupercategoryDetails = (superCategoryId) => {
  return (dispatch) => {
    axios
      .get(`/admin/super-category/details/${superCategoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_SUPER_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllCategory = (superCategoryId, id = 1, fetchAll = false) => {
  return (dispatch) => {
    axios
      .get(
        `/vendor/category/listing/${superCategoryId}?page_number=${id}&per_page_limit=${fetchAll ? 1000 : 10}`
      )
      .then((data) => {
        dispatch({ type: 'GET_ALL_CATEGORY', payload: data.data });
        if (!fetchAll)
          dispatch(getTotalPage(1, `vendor/category/listing/${superCategoryId}`));
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addCategory = (categoryData) => {
  return (dispatch) => {
    axios
      .post('/vendor/category/save', categoryData)
      .then((data) => {
        dispatch({ type: 'CREATE_CATEGORY', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Category successfully added' }
        });
      })
      .catch((error) => {
        try {
          dispatch({
            type: 'CREATE_CATEGORY_ERROR',
            payload: error.response.data
          });
        } catch {
          dispatch({
            type: 'CREATE_CATEGORY_ERROR',
            payload: 'please try again'
          });
        }
      });
  };
};
export const updateCategory = (categoryData) => {
  return (dispatch) => {
    axios
      .put('/vendor/category/update', categoryData)
      .then((data) => {
        dispatch({ type: 'UPDATE_CATEGORY', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Category successfully updated' }
        });
      })
      .catch((error) => {
        try {
          dispatch({
            type: 'UPDATE_CATEGORY_ERROR',
            payload: error.response.data
          });
        } catch {
          dispatch({
            type: 'UPDATE_CATEGORY_ERROR',
            payload: 'please try again'
          });
        }
      });
  };
};
export const deleteCategories = (categoryId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/vendor/category/delete/${categoryId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Category deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Category' }
        });
      }
    } else {
      try {
        await axios.delete(`/vendor/category/delete/${categoryId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Category deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete this Category' }
        });
      }
    }
  };
};

export const getCategoryDetails = (categoryId) => {
  return (dispatch) => {
    axios
      .get(`/vendor/category/details/${categoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllSubCategory = (categoryId) => {
  return (dispatch) => {
    axios
      .get(`/vendor/sub-category/listing/${categoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_SUBCATEGORY', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addSubCategory = (categoryData) => {
  return (dispatch) => {
    axios
      .post('/vendor/sub-category/save', categoryData)
      .then((data) => {
        dispatch({ type: 'CREATE_SUB_CATEGORY', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'subCategory successfully added' }
        });
      })
      .catch((error) => {
        try {
          dispatch({
            type: 'CREATE_SUB_CATEGORY_ERROR',
            payload: error.response.data
          });
        } catch {
          dispatch({
            type: 'CREATE_SUB_CATEGORY_ERROR',
            payload: 'please try again'
          });
        }
      });
  };
};
export const updateSubCategory = (categoryData) => {
  return (dispatch) => {
    axios
      .put('/vendor/sub-category/update', categoryData)
      .then((data) => {
        dispatch({ type: 'UPDATE_SUB_CATEGORY', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'subCategory successfully updated' }
        });
      })
      .catch((error) => {
        try {
          dispatch({
            type: 'UPDATE_SUB_CATEGORY_ERROR',
            payload: error.response.data
          });
        } catch {
          dispatch({
            type: 'UPDATE_SUB_CATEGORY_ERROR',
            payload: 'please try again'
          });
        }
      });
  };
};

export const updatePassword = (payload) => {
  return (dispatch) => {
    axios
      .post('/vendor/updatePassword', payload)
      .then((data) => {
        // dispatch({ type: 'UPDATE_SUB_CATEGORY', payload: payload});
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Vendor Password successfully updated' }
        });
      })
      .catch((error) => {
        try {
          // dispatch({
          //   type: 'UPDATE_SUB_CATEGORY_ERROR',
          //   payload: error.response.data
          // });
        } catch {
          // dispatch({
          //   type: 'UPDATE_SUB_CATEGORY_ERROR',
          //   payload: 'please try again'
          // });
        }
      });
  };
};
export const deleteSubCategories = (
  superCategoryId,
  categoryId,
  subCategoryId
) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(
          `/vendor/sub-category/delete?superCategoryId=${superCategoryId}&categoryId=${categoryId}&subCategoryId=${subCategoryId}`
        )
        .then(() => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Sub-Category deleted' }
          });
          resolve(true);
        })
        .catch((error) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Unable to delete Sub-Category' }
          });
          reject(false);
        });
    });
  };
};

export const getSubCategoryDetails = (categoryId, subCategoryId) => {
  return (dispatch) => {
    axios
      .get(
        `/vendor/sub-category/details/categoryId/${categoryId}/subCategoryId/${subCategoryId}`
      )
      .then((data) => {
        dispatch({ type: 'GET_SUB_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'Loading..' });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getCategory = (email) => {
  return (dispatch) => {
    axios
      .get(`/get/single/vendor/category/${localStorage.getItem('uid')}`)
      .then((doc) => {
        dispatch({ type: 'GET_CATEGORY', payload: doc.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
        // dispatch({ type: "GET_CATEGORY_ERROR", payload: error.error });
      });
  };
};

export const addProduct = (product) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      axios
        .post('/vendor/product/save', product)
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Product successfully added' }
          });
          resolve()
        })
        .catch((error) => {
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          }
          reject(error)
        });
    })
  };
};

export const getVendorDetails = () => {
  return (dispatch) => {
    axios
      .get(`/vendor/details`)
      .then((data) => {
        dispatch({ type: 'GET_VENDOR_DETAIL', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getSubCategory = (doc) => {
  return (dispatch) => {
    dispatch({ type: 'VENDOR_LOADING' });
    axios
      .get(`/get/subcategory/${doc.uid}/${doc.category}`)
      .then((info) => {
        dispatch({ type: 'SUB_CATEGORY', payload: info.data });
        dispatch({ type: 'VENDOR_UNLOADING' });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
        dispatch({ type: 'VENDOR_UNLOADING' });
      });
  };
};

export const getAllProducts = (q, superCategoryId, categoryId, subCategoryId, id = 1) => {
  return (dispatch) => {
    dispatch({ type: 'API_PROGRESS', payload: true });
    axios
      .get(`/vendor/product/listing?page_number=${id}&q=${q}&per_page_limit=10&superCategoryId=${superCategoryId}&categoryId=${categoryId}&subCategoryId=${subCategoryId}`)
      .then((data) => {
        dispatch({ type: 'API_PROGRESS', payload: false });
        dispatch({ type: 'ALL_PRODUCTS', payload: data.data.data });
        dispatch({ type: 'PRODUCT_COUNT', payload: data.data.total_data });
      })
      .catch((error) => {
        dispatch({ type: 'API_PROGRESS', payload: false });
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getCompleteProducts = (q, superCategoryId, categoryId, subCategoryId, id = 1) => {
  return (dispatch) => {
    axios
      .get(`/vendor/product/listing?page_number=${id}&q=${q}&per_page_limit=10000000&superCategoryId=${superCategoryId}&categoryId=${categoryId}&subCategoryId=${subCategoryId}`)
      .then((data) => {
        dispatch({ type: 'COMPLETE_PRODUCTS', payload: data.data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const deleteProduct = (productId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/vendor/product/delete/${productId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Product deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Product' }
        });
      }
    } else {
      try {
        await axios.delete(`/vendor/product/delete/${productId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Product deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete Product' }
        });
      }
    }
  };
};

export const updateProduct = (categoryData) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      axios
        .put('/vendor/product/update', categoryData)
        .then((data) => {
          dispatch({ type: 'UPDATE_PRODUCT', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Product successfully updated' }
          });
          resolve()
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_PRODUCT_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'UPDATE_PRODUCT_ERROR',
              payload: 'please try again'
            });
          }
        });
    });
  };
};

export const getProductDetails = (productId) => {
  return (dispatch) => {
    axios
      .get(`/vendor/product/details/${productId}`)
      .then((data) => {
        dispatch({ type: 'GET_PRODUCT_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const addWalletAmount = (id, amount) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios
          .post('/vendor/addMoneyToWallet', { id, amount })
          .then((data) => {
            dispatch({
              type: 'SUCCESS_MESSAGE',
              payload: { general: 'Wallet Updated' }
            });
            resolve(true);
          });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to Add Balance to your wallet' }
        });
        reject(false);
      }
    });
  };
};

export const getOrderList = (pageNumber, count = 10, startTime = '', endTime = '') => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/orderHistory?page_number=${pageNumber}&per_page_limit=${count}&startTime=${startTime}&endTime=${endTime}`)
        .then((resp) => {
          dispatch({
            type: 'ORDER_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => { });
    });
  };
};
export const getOrderListForDownload = (pageNumber, count = 10, startTime = '', endTime = '') => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/orderHistory?page_number=${pageNumber}&per_page_limit=${count}&startTime=${startTime}&endTime=${endTime}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => { });
    });
  };
};

export const updateVendorCommission = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/vendor/updateCommission', payload)
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Vendor commision successfully updated' }
          });
          dispatch({
            type: 'UPDATE_VENDOR_DETAIL',
            data: payload
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          } finally {
            reject(false);
          }
        });
    });
  };
};


export const getAllTransactions = (pageNumber, count = 10) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api_v_1/user/transactionHistory?page_number=${pageNumber}&per_page_limit=${count}`)
        .then((resp) => {
          dispatch({
            type: 'VENDOR_TRANSACTION_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => { });
    });
  };
};

const setAuthorizationHandler = (token) => {
  const fireToken = `Bearer${' ' + token}`;
  localStorage.setItem('token', fireToken);
};
